/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/*
 * @Description:
 * @Author: wjx
 * @Date: 2019-07-25 11:26:06
 */
import request from '@/interceptor/request';
import qs from 'qs';

var post = function post(url, data) {
  for (var _len = arguments.length, options = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    options[_key - 2] = arguments[_key];
  }

  return request.post.apply(request, [url, qs.stringify(data)].concat(options));
};

var get = function get(url, data) {
  return request.get(url, data);
};

var upload = function upload(url, data) {
  for (var _len2 = arguments.length, options = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    options[_key2 - 2] = arguments[_key2];
  }

  return request.post.apply(request, [url, data].concat(options));
};

export { get, post, upload };
export default request;